import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_MINECRAFT: unique symbol = symbolName("minecraft");
